var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRevolving = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.05 5.7C4.47 5.7 4 6.17 4 6.75v7.97c0 .58.47 1.05 1.05 1.05h4.43a.85.85 0 0 1 0 1.7H5.05a2.75 2.75 0 0 1-2.75-2.75V6.75A2.75 2.75 0 0 1 5.05 4H18.8a2.75 2.75 0 0 1 2.75 2.75v3.294a.85.85 0 0 1-1.7 0V6.75c0-.58-.47-1.05-1.05-1.05z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.7 9.45H3.15v-1.7H20.7z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.85 15.292a4.82 4.82 0 0 0-4.53-3.192c-2.65 0-4.8 2.15-4.8 4.8s2.15 4.8 4.8 4.8a4.8 4.8 0 0 0 3.244-1.263.85.85 0 1 0-1.147-1.254A3.1 3.1 0 0 1 16.32 20c-1.71 0-3.1-1.39-3.1-3.1s1.39-3.1 3.1-3.1c1.347 0 2.497.861 2.93 2.067a.85.85 0 1 0 1.6-.575",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.653 15.491a.85.85 0 0 0 .778.916l2.95.24a.85.85 0 0 0 .138-1.694l-2.95-.24a.85.85 0 0 0-.916.778",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.772 12.003a.85.85 0 0 0-.919.775l-.25 2.95a.85.85 0 0 0 1.694.144l.25-2.95a.85.85 0 0 0-.775-.92",
  clipRule: "evenodd"
})));
export default SvgRevolving;